import TurndownService from 'turndown';

export const GetPageContent = () => {
    const contentHtml = document.querySelector('main')?.innerHTML || document.body.innerHTML;
    const documentTitle = document.title;
    const turndownService = new TurndownService({
        headingStyle: 'atx',
        codeBlockStyle: 'fenced',
    });
    const parser = new DOMParser();
    const doc = parser.parseFromString(contentHtml, 'text/html');
    const unwantedTags = doc.querySelectorAll('script, style, meta, link, noscript');
    unwantedTags.forEach(tag => tag.remove());
    let markdown = turndownService.turndown(doc.body.innerHTML);
    if (documentTitle) {
        markdown = `# Page Title: ${documentTitle}\n\n${markdown}`;
    }
    return markdown;
};

export default GetPageContent;